<template>
  <cTable
    ref="table"
    :fields="fields"
    :header="header"
    :methods="methods"
    :modals="modals"
  >
  </cTable>
</template>

<script>
import {
  getclaimFee,
  getclaimFeeDetail,
  updateClaimFee,
  delClaimFee,
  confirmClaimFee,
  getExchangeRate,
  writeOff,
  removeClaimFee,
  addClaimFee,
} from "@/api/finance/claim_fee";
import { getAllClient } from "@/api/user/client";
import { getCompanies } from "@/api/user/client";
import { getSelectType } from "@/api/public";
import copyClick from "@/utils/copyClick";
import cTable from "@/base/common/index";
export default {
  name: "claim_fee",
  components: {
    cTable,
  },
  data() {
    let optionsLabel = ["transfer_order", "self_mention", "monthly_fee"];
    let options = [
      { label: optionsLabel[0], value: 1 },
      { label: optionsLabel[1], value: 2 },
      { label: optionsLabel[2], value: 3 },
    ];
    return {
      detailList: [],
      methods: {
        list: getclaimFee,
        getclaimFeeDetail,
        getAllClient,
        getCompanies,
        updateClaimFee,
        delClaimFee,
        confirmClaimFee,
        getExchangeRate,
        writeOff,
        removeClaimFee,
        addClaimFee,
      },
      modals: {
        showDetails: {
          header: {
            show: () => true,
            copy: true,
            btns: [
              {
                name: this.$t("export"),
                fnName: "exportFun",
                bind: {
                  type: "primary",
                  style: "margin-right: 10px",
                },
                // disabled() {
                //   return !this.selectAll.length;
                // },
              },
              {
                name: this.$t("MoveOut"),
                fnName: "moveFun",
                bind: {
                  type: "success",
                },
                disabled() {
                  return !this.selectAll.length;
                },
                show() {
                  return this.pageConfig.data.status != 9;
                },
                id: 994,
              },
            ],
            methods: {
              copy({ row }) {
                copyClick.copyToClipboard(row.bill_number, this);
              },
              moveFun({ row }) {
                this.$Modal.confirm({
                  title:
                    this.$t("MoveOut") +
                    this.$t("claim") +
                    this.$t("Odd_Numbers"),
                  width: 300,
                  content: this.$t("titleModal"),
                  onOk: () => {
                    let data = {
                      pid: this.pageConfig.data.id,
                      ids: this.selectAll.map((item) => item.id),
                    };
                    this.$page
                      .handleRequestMethods("removeClaimFee", data, true, true)
                      .then((res) => {
                        this.getList();
                      });
                  },
                });
              },
              exportFun({ row }) {
                // this.$page.exportExc({
                //   data: this.selectAll,
                //   fields: this.table.fields,
                // });
                // console.log(this.pageConfig.data.id);
                // return false;
                this.$page
                  .handleRequestMethods(
                    "getclaimFeeDetail",
                    {
                      export: "1",
                      id: this.pageConfig.data.id,
                    },
                    true,
                    true
                  )
                  .then((res) => {
                    window.open(this.$globalUrl + res.payload.src);
                  });
              },
            },
          },
          config: {
            listFn: "getclaimFeeDetail",
            modalBind: {
              width: 80,
              transfer: true,
              draggable: true,
              sticky: true,
              "reset-drag-position": true,
              styles: {
                top: "30px",
              },
            },
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px",
              },
            },
            formBind: {},
          },
          footer: { show: () => false },
          table: {
            config: {
              height: 750,
            },
            footer: {
              show: true,
            },
            fields: [
              {
                type: "checkbox",
                align: "center",
                fixed: "left",
                width: 60,
              },
              {
                name: () => this.$t("claim") + this.$t("Odd_Numbers"),
                key: "airway_number",
                width: 130,
              },
              {
                name: () => this.$t("clientName"),
                key: "client_name",
                width: 120,
              },
              {
                name: () => this.$t("claim") + this.$t("reChAmount"),
                key: "amount",
                width: 100,
              },
              {
                name: () => this.$t("claim") + this.$t("currency_t"),
                key: "currency",
                width: 80,
              },
              {
                name: () => this.$t("to") + this.$t("rate"),
                key: "to_rate",
                width: 80,
              },
              {
                name: () => this.$t("to") + this.$t("currency_t"),
                key: "to_currency",
                width: 80,
              },
              {
                name: () => this.$t("to") + this.$t("reChAmount"),
                key: "to_amount",
                width: 100,
              },
              {
                name: () => this.$t("auditOrder") + this.$t("tip"),
                key: "status_txt",
                width: 100,
              },
              {
                name: () => this.$t("claim") + this.$t("audit_process"),
                key: "verify",
              },
            ],
          },
        },
        updateFee: {
          methods: {
            ok({ row, close }) {
              this.$page
                .handleRequestMethods("updateClaimFee", row, true, true)
                .then((res) => {
                  this.$page.getList();
                  close();
                });
            },
          },
          config: {
            modalBind: {
              width: 600,
              draggable: true,
            },
            formBind: {
              labelWidth: 100,
            },
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px",
              },
            },
            rules: {
              bill_name: [
                {
                  required: true,
                  trigger: "change",
                },
              ],
            },
          },
          grid: [{ bill_name: 24 }, { remarks: 24 }],
          fields: [
            {
              name: () => this.$t("bill_name"),
              key: "bill_name",
              component: "Input",
              placeholder() {
                return this.$t("enter") + this.$t("bill_name");
              },
            },
            {
              name: () => this.$t("Remarks"),
              key: "remarks",
              component: "Input",
              bind: {
                type: "textarea",
                autosize: { minRows: 2 },
              },
              placeholder() {
                return this.$t("enter") + this.$t("Remarks");
              },
            },
          ],
        },
        rate: {
          methods: {
            ok({ row, close }) {
              this.$page
                .handleRequestMethods("getExchangeRate", row, true, true)
                .then((res) => {
                  this.$page.getList();
                  close();
                });
            },
          },
          config: {
            modalBind: {
              width: 600,
              draggable: true,
            },
            formBind: {
              labelWidth: 100,
            },
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px",
              },
            },
            rules: {
              rate: [
                {
                  required: true,
                  type: "number",
                  trigger: "blur",
                },
              ],
              currency: [
                {
                  required: true,
                  trigger: "change",
                },
              ],
            },
          },
          grid: [{ rate: 24 }, { currency: 24 }],
          fields: [
            {
              name: () => this.$t("to") + this.$t("rate"),
              key: "rate",
              component: "InputNumber",
              placeholder() {
                return this.$t("enter") + this.$t("to") + this.$t("rate");
              },
              bind: {
                min: 0,
                max: 99999,
                style: {
                  width: "100%",
                },
              },
              default: 0,
            },
            {
              name: () => this.$t("to") + this.$t("currency_t"),
              key: "currency",
              component: "Select",
              options: [
                {
                  value: "CNY",
                  label: "CNY",
                },
                {
                  value: "USD",
                  label: "USD",
                },
              ],
              placeholder() {
                return (
                  this.$t("select") + this.$t("to") + this.$t("currency_t")
                );
              },
            },
          ],
        },
        add: {
          methods: {
            ok({ row, close }) {
              this.$page
                .handleRequestMethods("addClaimFee", row, true, true)
                .then((res) => {
                  this.$page.getList();
                  close();
                });
            },
          },
          config: {
            modalBind: {
              width: 600,
              draggable: true,
            },
            formBind: {
              labelWidth: 100,
            },
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px",
              },
            },
            rules: {
              airway_number: [
                {
                  required: true,
                  trigger: "blur",
                },
              ],
            },
          },
          grid: [{ airway_number: 24 }],
          fields: [
            {
              name: () => this.$t("claim") + this.$t("Odd_Numbers"),
              key: "airway_number",
              component: "Input",
              placeholder() {
                return (
                  this.$t("enter") + this.$t("claim") + this.$t("Odd_Numbers")
                );
              },
              bind: {
                type: "textarea",
                autosize: { minRows: 2 },
              },
            },
          ],
        },
      },
      header: {
        searchs: [
          {
            key: "dateType",
            placeholder() {
              return this.$t("select") + this.$t("date") + this.$t("type");
            },
            clearable: false,
            component: "Select",
            options: [],
            methods: {
              async list({ field, searchForm }) {
                let res = (await getSelectType(["BILL_TIME_TYPE"])).data
                  .payload["BILL_TIME_TYPE"];
                field.options = res;
                searchForm[field.key] = res[0].value;
                this.$forceUpdate();
              },
            },
          },
          {
            key: "startTime",
            component: "DatePicker",
            placeholder() {
              return (
                this.$t("select") +
                this.$t("start") +
                this.$t("date") +
                this.$t("time")
              );
            },
            bind: {
              type: "datetime",
              options: {
                disabledDate(time) {
                  return time.getTime() > Date.now();
                },
              },
              style: {
                width: "175px",
              },
            },
            methods: {
              "on-change"({ searchForm }) {
                searchForm.startTime = searchForm.startTime
                  ? this.$page.format.timeFormat(searchForm.startTime)
                  : "";
              },
            },
          },
          {
            key: "endTime",
            component: "DatePicker",
            placeholder() {
              return (
                this.$t("select") +
                this.$t("end") +
                this.$t("date") +
                this.$t("time")
              );
            },
            bind: {
              type: "datetime",
              options: {
                disabledDate(time) {
                  return time.getTime() > Date.now();
                },
              },
              style: {
                width: "175px",
              },
            },
            methods: {
              "on-change"({ searchForm }) {
                let time = this.$page.format.timeFormat(searchForm.endTime);
                if (time.slice(-8) === "00:00:00") {
                  time = time.split(" ")[0] + " " + "23:59:59";
                  searchForm.endTime = time;
                }
              },
            },
          },
          {
            name: () => this.$t("ownership"),
            key: "ownership",
            component: "Select",
            placeholder() {
              return this.$t("select") + this.$t("ownership");
            },
            options: [],
            config: { label: "title", value: "id" },
            methods: {
              async list({ field }) {
                field.options = (
                  await this.$page.handleRequestMethods("getCompanies")
                ).payload;
                this.$forceUpdate();
              },
            },
          },
          {
            key: "client_id",
            placeholder() {
              return this.$t("select") + this.$t("clientName");
            },
            component: "Select",
            config: {
              value: "id",
              label: "account",
            },
            methods: {
              async list({ field }) {
                field.options = (
                  await this.$page.handleRequestMethods("getAllClient")
                ).payload.rows;
                this.$forceUpdate();
              },
            },
          },
          {
            key: "status",
            placeholder() {
              return this.$t("select") + this.$t("bill1") + this.$t("tip");
            },
            component: "Select",
            options: [],
            methods: {
              async list({ field, searchForm }) {
                let res = (await getSelectType(["BILL_STATUS_TYPE"])).data
                  .payload["BILL_STATUS_TYPE"];
                field.options = res;
                this.$forceUpdate();
              },
            },
          },
          // {
          //   key: "warehouse_id",
          //   placeholder() {
          //     return this.$t("select") + this.$t("warehouseName");
          //   },
          //   component: "Select",
          //   config: {
          //     value: "id",
          //     label: "title"
          //   },
          //   methods: {
          //     async list({ field }) {
          //       field.options = (
          //         await this.$page.handleRequestMethods("getWarehouse")
          //       ).payload.rows;
          //       this.$forceUpdate();
          //     }
          //   }
          // },
          {
            key: "keywordsType",
            placeholder() {
              return this.$t("select") + this.$t("keyword") + this.$t("type");
            },
            component: "Select",
            config: {
              label({ row }) {
                return this.$t(row.label);
              },
            },
            options: [],
            methods: {
              async list({ field, searchForm }) {
                let res = (await getSelectType(["CLAIM_BILL_KEYWORDS_TYPE"]))
                  .data.payload["CLAIM_BILL_KEYWORDS_TYPE"];
                field.options = res;
                this.$forceUpdate();
              },
            },
          },
          {
            key: "keywords",
            placeholder() {
              return this.$t("keyword");
            },
            component: "Input",
            bind: {
              type: "textarea",
              rows: 1,
            },
          },
        ],
        btns: {
          list: [
            {
              name: () => this.$t("export"),
              type: "export",
              fnName: "export",
              bind: {
                type: "primary",
              },
              disabled() {
                return !this.selectAll.length;
              },
            },
          ],
          methods: {
            export() {
              this.exportExc();
            },
          },
        },
      },
      fields: [
        {
          type: "checkbox",
          align: "center",
          fixed: "left",
          width: 60,
        },
        {
          name: () => this.$t("bill_number"),
          key: "bill_number",
          copy: true,
          component: "Button",
          copy: true,
          fixed: "left",
          width: 190,
          bind: {
            type: "primary",
            size: "small",
          },
          methods: {
            async click({ row }) {
              this.$page
                .getModal("showDetails")
                .setTitle(this.$t("bill_number") + row.bill_number);
              this.$page.getModal("showDetails").open({ row }, function () {
                let data = {
                  id: row.id,
                  status: row.status,
                };
                this.pageConfig.data = data;
                this.getList(data);
              });
            },
          },
        },
        {
          name: () => this.$t("bill_name"),
          key: "bill_name",
          minWidth: 100,
        },
        {
          name: () => this.$t("clientName"),
          key: "client_name",
          minWidth: 100,
        },
        {
          name: () => this.$t("ownership"),
          key: "ownership",
          minWidth: 100,
        },
        {
          name: () => this.$t("bill_type"),
          key: "status_txt",
          minWidth: 100,
        },
        {
          name: () => this.$t("reChAmount") + "(RNB)",
          key: "amount_cny",
          minWidth: 100,
        },
        {
          name: () => this.$t("reChAmount") + "(USD)",
          key: "amount_usd",
          minWidth: 100,
        },
        {
          name: () => this.$t("to") + this.$t("rate"),
          key: "to_rate",
          minWidth: 100,
        },
        {
          name: () => this.$t("to") + this.$t("currency_t"),
          key: "to_currency",
          minWidth: 100,
        },
        {
          name: () => this.$t("to") + this.$t("reChAmount"),
          key: "to_amount",
          minWidth: 100,
        },
        {
          name: () => this.$t("createUser"),
          key: "create_name",
          width: 150,
        },
        {
          name: () => this.$t("createTime"),
          key: "create_time",
          width: 150,
        },
        {
          name: () => this.$t("comfirmUser"),
          key: "confirm_name",
          width: 150,
        },
        {
          name: () => this.$t("confirm_time"),
          key: "confirm_time",
          width: 150,
        },
        {
          name: () => this.$t("writeOffUser"),
          key: "check_name",
          width: 150,
        },
        {
          name: () => this.$t("check_time"),
          key: "check_time",
          width: 150,
        },
        {
          name: () => this.$t("order_desc"),
          key: "remarks",
          minWidth: 100,
        },
        {
          type: "btns",
          width: 150,
          name: () => this.$t("operation"),
          fixed: "right",
          list: [
            {
              name: () => this.$t("addTo"),
              type: "add",
              fnName: "addFun",
              bind: {
                type: "success",
              },
              disabled({ row }) {
                return row.status == 9;
              },
              id: 993,
            },
            {
              name: () => this.$t("confirm") + this.$t("bill1"),
              type: "confirm",
              fnName: "confirmFun",
              bind: {
                type: "success",
              },
              disabled({ row }) {
                return row.status != 1;
              },
              id: 988,
            },
            {
              name: () => this.$t("rate"),
              type: "rate",
              fnName: "rateFun",
              bind: {
                type: "warning",
              },
              disabled({ row }) {
                return row.status == 9;
              },
              id: 987,
            },
            {
              name: () => this.$t("writeOff"),
              type: "writeOff",
              fnName: "writeOffFun",
              bind: {
                type: "error",
              },
              disabled({ row }) {
                return row.status != 4;
              },
              id: 989,
            },
            {
              name: () => this.$t("update"),
              type: "update",
              fnName: "update",
              bind: {
                type: "success",
              },
              id: 991,
            },
            {
              name: this.$t("delete"),
              type: "delete",
              fnName: "delete",
              disabled({ row }) {
                return row.status == 9;
              },
              id: 992,
            },
          ],

          methods: {
            addFun({ row }) {
              let data = {
                id: row.id,
              };
              this.getModal("add").open(data, function () {
                this.setTitle(
                  this.$t("addTo") + this.$t("claim") + this.$t("Odd_Numbers")
                );
              });
            },
            confirmFun({ row }) {
              this.$Modal.confirm({
                title: this.$t("confirm") + this.$t("bill1"),
                width: 300,
                content: this.$t("titleModal"),
                onOk: () => {
                  this.handleRequestMethods(
                    "confirmClaimFee",
                    row.id,
                    true,
                    true
                  ).then((res) => {
                    this.getList();
                  });
                },
              });
            },
            rateFun({ row }) {
              let data = {
                id: row.id,
                rate: row.to_rate,
                currency: row.to_currency,
              };
              this.getModal("rate").open(data, function () {
                this.setTitle(this.$t("bill1") + this.$t("rate"));
              });
            },
            writeOffFun({ row }) {
              this.$Modal.confirm({
                title: this.$t("writeOff") + this.$t("bill1"),
                width: 300,
                content: this.$t("titleModal"),
                onOk: () => {
                  this.handleRequestMethods(
                    "writeOff",
                    row.id,
                    true,
                    true
                  ).then((res) => {
                    this.getList();
                  });
                },
              });
            },
            update({ row }) {
              this.getModal("updateFee").setTitle(
                this.$t("update") + this.$t("bill1")
              );
              this.getModal("updateFee").open({
                id: row.id,
                bill_name: row.bill_name,
                remarks: row.remarks,
              });
            },
            delete({ row }) {
              this.$Modal.confirm({
                title: this.$t("delete"),
                width: 300,
                content: this.$t("titleModal"),
                onOk: () => {
                  this.handleRequestMethods(
                    "delClaimFee",
                    row.id,
                    true,
                    true
                  ).then((res) => {
                    this.getList();
                  });
                },
              });
            },
          },
        },
      ],
    };
  },
};
</script>
